import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-pncl-progress-bar',
  templateUrl: './pncl-progress-bar.component.html',
  styleUrls: ['./pncl-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
})
export class PnclProgressBarComponent {}
